// Italian — mirrors src/i18n/local/en/common.ts for Italian-speaking buyers.

const common = {
  "nav.home": "Home",
  "nav.products": "Prodotti",
  "nav.factory": "Fabbrica",
  "nav.about": "Chi siamo",
  "nav.contact": "Contatti",
  "nav.requestQuote": "Richiedi un preventivo",
  "nav.menu": "Menu",
  "nav.language": "Lingua",

  "cta.requestQuote": "Richiedi un preventivo",
  "cta.exploreCatalog": "Esplora il catalogo",
  "cta.contactUs": "Contattaci",
  "cta.scheduleFactoryVisit": "Prenota una visita in fabbrica",
  "cta.requestSample": "Richiedi un campione",
  "cta.viewAll": "Tutti i prodotti",

  "common.tbd": "[Da confermare da Forwaro]",
  "common.category": "Categoria",
  "common.material": "Materiale",
  "common.style": "Stile",
  "common.filters": "Filtri",
  "common.resetAll": "Reimposta",
  "common.details": "Dettagli",

  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",
  "whatsapp.cta": "Scrivici su WhatsApp",
  "wechat.cta": "Aggiungici su WeChat",

  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "La casa è",
  "home.hero.headline.line2Highlight": "il centro di tutto",
  "home.hero.headline.line3": "in una vita affollata.",
  "home.hero.subheadline": "Forwaro Furniture (風華國際) è un produttore OEM / ODM con sede a Dongguan che unisce il design d'arredo a una qualità produttiva costante per gli importatori di Medio Oriente, Europa, Americhe e Asia.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "Linee di prodotto",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "Produzione su misura",
  "home.hero.stat3.value": "Dongguan",
  "home.hero.stat3.label": "Zona industriale di Min Tian",
  "home.hero.stat4.value": "Globale",
  "home.hero.stat4.label": "Partnership per l'export",
  "home.hero.scroll": "Scorri",

  "home.categories.kicker": "La nostra gamma",
  "home.categories.heading": "Sei linee di prodotto, un'unica fabbrica di fiducia",
  "home.categories.description": "Tavoli da pranzo, tavolini da caffè, consolle, sedie, divani e mobili TV: le sei linee di arredo B2B che Forwaro produce per l'export.",

  "home.about.kicker": "Chi è Forwaro",
  "home.about.heading.line1": "Design del mobile,",
  "home.about.heading.line2": "artigianato coerente.",
  "home.about.philosophy.en":
    "La casa è il centro di una vita impegnata, dove l'estetica dell'abitare diventa il gusto e l'aspirazione di chi ha successo. Forwaro Furniture difende una coerenza di design e qualità: estetica e artigianato che si completano a vicenda in ogni casa.",
  "home.about.location": "Forwaro Furniture (風華國際有限公司) è stata fondata a Taiwan nel 1991 e produce nella Cina continentale dal 2006. Oggi opera dalla Min Tian Industrial Zone, a Shatian Town, Dongguan. Forwaro collabora con importatori che apprezzano una lavorazione onesta e consegne affidabili.",
  "home.about.highlight1.title": "OEM e ODM",
  "home.about.highlight1.body":
    "Produzione su misura — da private label a progetti completamente personalizzati.",
  "home.about.highlight2.title": "QC pronto per l'export",
  "home.about.highlight2.body":
    "Ispezioni su falegnameria, tappezzeria, finiture e imballaggio per il trasporto marittimo.",
  "home.about.highlight3.title": "Marmo naturale e acciaio",
  "home.about.highlight3.body": "Piani distintivi in marmo naturale, abbinati a basi in acciaio inossidabile galvanizzato e ferro.",
  "home.about.highlight4.title": "Portata globale",
  "home.about.highlight4.body": "Da Dongguan serviamo importatori in Medio Oriente, Europa, Americhe e Asia.",
  "home.about.badgeLocation": "Dongguan, Cina",
  "home.about.badgeZone": "Zona industriale Min Tian",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "Su misura e private label",

  "home.featured.kicker": "Anteprima catalogo",
  "home.featured.heading": "Un'anteprima delle sei linee di Forwaro",
  "home.featured.description": "Codici modello Forwaro autentici, con materiali e dimensioni confermati. Contattaci per le specifiche complete e un preventivo.",


  "home.markets.kicker": "Portata globale",
  "home.markets.heading": "I mercati che serviamo",
  "home.markets.description":
    "Forwaro collabora con importatori, distributori, gruppi hospitality e progetti residenziali in quattro continenti.",

  "home.process.heading": "Come lavoriamo con voi",
  "home.process.description":
    "Dalla prima richiesta al carico del container — il flusso di esportazione standard di Forwaro.",

  "footer.getInTouch.kicker": "Contatti",
  "footer.getInTouch.heading":
    "Inizia il tuo import di mobili\ncon Forwaro",
  "footer.getInTouch.description":
    "Il nostro team export prepara preventivi su misura, campioni e documentazione completa per il tuo mercato.",
  "footer.contact.email": "Email",
  "footer.contact.phone": "Telefono",
  "footer.contact.fax": "Fax",
  "footer.contact.factory": "Fabbrica",
  "footer.contact.whatsappNote":
    "Canali WhatsApp e WeChat — da confermare da Forwaro.",
  "footer.form.heading": "Richiedi un preventivo",
  "footer.form.name": "Nome completo",
  "footer.form.email": "Email",
  "footer.form.company": "Azienda",
  "footer.form.country": "Paese",
  "footer.form.countryPlaceholder": "Seleziona un paese",
  "footer.form.message": "Messaggio",
  "footer.form.messagePlaceholder":
    "Descrivi i requisiti, le quantità e il mercato di destinazione…",
  "footer.form.submit": "Invia richiesta",
  "footer.form.sending": "Invio…",
  "footer.form.success.heading": "Inviato!",
  "footer.form.success.body":
    "Il team export risponderà entro due giorni lavorativi.",
  "footer.form.sendAnother": "Invia un altro messaggio",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱. Produttore OEM/ODM con sede a Dongguan, al servizio di importatori in Medio Oriente, Europa, Americhe e Asia.",
  "footer.col.products": "Prodotti",
  "footer.col.company": "Azienda",
  "footer.col.markets": "Mercati export",
  "footer.col.regional": "Cerchi un rappresentante regionale?",
  "footer.copyright": "Tutti i diritti riservati.",
};

export default common;
